import { Component, OnInit, Input, ViewChild } from '@angular/core';
import { BaseRequestService } from 'src/app/front-user/shipyard-service/services/base-request.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BaseRequest } from 'src/app/shared/models/base-request.model';
import { SUTransitReviewDecision, SUTransitApprovalDecision, Languages, ServiceStatus, FormMode } from 'src/app/shared/models/enums.model';
import { GlobalServices } from 'src/app/shared/services/global.service';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { User } from 'src/app/front-user/shared/models/user.model';
import { AuthenticationService } from 'src/app/front-user/shared/services/authentication.service';
import { ResponseObject } from 'src/app/shared/models/response-object.model';
import { AlertService } from 'src/app/shared/components/alert/alert.service';
import { AgentService } from 'src/app/front-user/services/e-booking/shared/services/agent.service';
import { TranslateService } from '@ngx-translate/core';
import { first } from 'rxjs/operators';
import { EntranceRequestComponent } from 'src/app/front-user/services/small-units/entrance-request/entrance-request.component';
import { SmallUnitsAdminService } from '../shared/services/small-units.service.admin';
import { SmallUnitadminDTO } from '../shared/models/small-units-admin.model';
import { SmallUnitsServiceFE } from 'src/app/front-user/services/small-units/shared/services/small-units.service';
import { SmallUnitRequest } from 'src/app/front-user/services/small-units/shared/models/Small-Unit-Request.model';
import { CustomValidators } from 'src/app/front-user/shipyard-service/models/custom-validator';
//import { timeStamp } from 'console';

@Component({
  selector: 'app-review-transit-request',
  templateUrl: './review-transit-request-component.html'
})


export class ReviewTransitRequestComponent implements OnInit {
  submitted = false;
  loading = false;
  baseRequestId: string = '';
  requestStatus: number;
  baseRequestDTO: BaseRequest//= new BaseRequest();
  decision = SUTransitReviewDecision;
  decisionKeys = Object.keys(this.decision);
  displayedLang: string;
  decisionValue: number;
  reviewTransitRequestForm: FormGroup;
  user: User = new User();
  agent: User = new User();
  smallunitRequestObj: SmallUnitRequest = new SmallUnitRequest();
  adminDecisionObject: SmallUnitadminDTO = new SmallUnitadminDTO();
  showRequest = false;
  agentId: string;
  public FormMode: any = FormMode;
  public formMode: any = FormMode.Add;
  isLoaded: boolean = false;
  isErrorMessage: boolean = false;
  numberRegex: string = '^[0-9]+(\\.?[0-9]+)?$';
  @Input() public isShow: boolean = true;
  //@ViewChild('EntranceRequest') EntranceRequest: EntranceRequestComponent;
  responseObj: ResponseObject = new ResponseObject();
  lockTaskErrorMessage: boolean = false;
  TransitPostponedByIS: boolean = false;
  ISNote: string = '';

  constructor(private formBuilder: FormBuilder, private baseRequestService: BaseRequestService,
    private globalSrv: GlobalServices,
    private route: ActivatedRoute, private router: Router,
    private translate: TranslateService,
    private SmallUnitServ: SmallUnitsServiceFE,
    private authenticationService: AuthenticationService, private alertService: AlertService,
    private SmallUnitAdminServ: SmallUnitsAdminService, private agentSrv: AgentService) {
    // this.isShow = true;
    this.decisionKeys = this.decisionKeys.slice(this.decisionKeys.length / 2);
    this.displayedLang = this.globalSrv.getLanguage() == Languages.Arabic ? 'NameAR' : 'NameEN';
    //this.baseRequestId = this.route.snapshot.params.Id;
    if (history.state.data && history.state.data.requestId) {
      this.baseRequestId = history.state.data.requestId;
      this.getBaseRequest();
    } else {
      window.history.back();
    }

    this.user = this.globalSrv.user;

  }

  ngOnInit() {

    this.buildForm(null);
  }

  buildForm(decision) {
    this.reviewTransitRequestForm = this.formBuilder.group({
      Decision: ['', [Validators.required]],
    });
    if (decision == SUTransitReviewDecision.MoreInformation) {
      this.reviewTransitRequestForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        MoreInformation: ['', [Validators.required]],
      });
    }
    else if (decision == SUTransitReviewDecision.SEND_TO_ISDEPARTEMENT) {
      this.reviewTransitRequestForm = this.formBuilder.group({
        Decision: ['', [Validators.required]],
        TransitDate: ['', [Validators.required]],
      });
    }
  }
  changeDecision(value) {
    this.buildForm(value);
    this.reviewTransitRequestForm.patchValue({
      Decision: value
    });
    this.decisionValue = value;
  }

  get f() {
    return this.reviewTransitRequestForm.controls;
  }

  getBaseRequest() {
    this.SmallUnitServ.get(this.baseRequestId).subscribe(
      (resObj: ResponseObject) => {
        this.responseObj = resObj;
        if (this.responseObj.Success) {
          this.smallunitRequestObj = this.responseObj.Data;
          this.requestStatus = this.smallunitRequestObj.StatusId;
          this.agentId = this.smallunitRequestObj.RequestorId;
          this.isLoaded = true;
          // check if transit postponed
          if (this.smallunitRequestObj.StatusId == ServiceStatus.SmallUnit_TransitPostponed && (this.smallunitRequestObj.ISActionId == SUTransitApprovalDecision.Postpone || this.smallunitRequestObj.SmallUnitConfirmActionId == SUTransitApprovalDecision.Postpone)) {
            this.TransitPostponedByIS = true;
            this.ISNote = this.smallunitRequestObj.ISNotes;
          }
          if (history.state.data && history.state.data.isCompleted) {

            this.decisionValue = this.smallunitRequestObj.SmallUnitTransitActionId;

            if (this.smallunitRequestObj.SmallUnitTransitActionId == SUTransitReviewDecision.MoreInformation) {
              this.buildForm(this.decisionValue);
              this.reviewTransitRequestForm.patchValue({
                Decision: SUTransitReviewDecision.MoreInformation,
                MoreInformation: this.smallunitRequestObj.SmallUnitTransitMoreInformation
              });
            }
            else {
              this.buildForm(this.decisionValue);
              this.reviewTransitRequestForm.patchValue({
                Decision: SUTransitReviewDecision.SEND_TO_ISDEPARTEMENT,
                TransitDate: new Date(this.smallunitRequestObj.SmallUnitTransitDate),
              });
            }
            this.formMode = FormMode.Readonly;
            this.reviewTransitRequestForm.disable();
          }
          else if (this.requestStatus == ServiceStatus.SmallUnit_TransitRequestPendingReview || this.requestStatus == ServiceStatus.SmallUnit_TransitPostponed) {
            this.formMode = FormMode.Add;
            this.reviewTransitRequestForm.enable();
          }
          else {
            this.formMode = FormMode.Readonly;
            this.reviewTransitRequestForm.disable();
            if (this.smallunitRequestObj.SmallUnitTransitActionId == SUTransitReviewDecision.MoreInformation) {
              this.buildForm(this.decisionValue);
              this.reviewTransitRequestForm.patchValue({
                Decision: SUTransitReviewDecision.MoreInformation,
                MoreInformation: this.smallunitRequestObj.SmallUnitTransitMoreInformation
              });
            }
            else {
              this.decisionValue = this.smallunitRequestObj.SmallUnitTransitActionId;
              this.buildForm(this.decisionValue);
              this.reviewTransitRequestForm.patchValue({
                Decision: SUTransitReviewDecision.SEND_TO_ISDEPARTEMENT,
                TransitDate: new Date(this.smallunitRequestObj.SmallUnitTransitDate),
              });
            }

          }
        }
      }
    )
  }


  onSubmit(b) {

    this.submitted = true;
    // stop here if form is invalid
    if (this.reviewTransitRequestForm.invalid) {
      return;
    }
    this.alertService.clear();
    this.globalSrv.isLoaderEnabled = true;
    this.loading = true;

    // this.adminDecisionObject = this.reviewTransitRequestForm.value;
    this.adminDecisionObject.AdminEmail = this.user.UserName;
    this.adminDecisionObject.Id = this.baseRequestId;
    this.adminDecisionObject.SmallUnitTransitActionId = this.reviewTransitRequestForm.controls.Decision.value;
    if (this.adminDecisionObject.SmallUnitTransitActionId == SUTransitReviewDecision.MoreInformation) {
      this.adminDecisionObject.SmallUnitTransitMoreInformation = this.reviewTransitRequestForm.controls.MoreInformation.value;
    }
    else if (this.adminDecisionObject.SmallUnitTransitActionId == SUTransitReviewDecision.SEND_TO_ISDEPARTEMENT) {
      if (this.reviewTransitRequestForm.get("TransitDate").value) {
        var selectedTransitDate = this.reviewTransitRequestForm.get("TransitDate").value.toLocaleString('en-US');
        this.reviewTransitRequestForm.controls['TransitDate'].setValue(selectedTransitDate);
      }
      this.adminDecisionObject.SmallUnitTransitDate = this.reviewTransitRequestForm.controls.TransitDate.value;
    }

    this.SmallUnitAdminServ.SmallUnitsTransitDecision(this.adminDecisionObject)
      .subscribe(
        (data: ResponseObject) => {
          if (data.Success) {
            this.globalSrv.isLoaderEnabled = false;
            //this.alertService.success('Decision Submitted Successfully', false);
            this.reviewTransitRequestForm.reset();
            this.loading = false;
            this.showRequest = true;
            this.isErrorMessage = false;
          }
          else if (data.ErrorMessages.find(e => e == "TaskCompletedByAnotherUser") != null) {
            this.lockTaskErrorMessage = true;
            this.showRequest = true;
            this.globalSrv.isLoaderEnabled = false;
          }
          else {
            this.globalSrv.isLoaderEnabled = false;
            this.showRequest = true;
            this.isErrorMessage = true;
            //this.alertService.error(this.translate.instant('FRONT_USER.ERRORS_MESSAGES.'+data.ErrorMessages[0]), false);

            this.loading = false;
          }

        });
  }
}
